module.exports = __webpack_public_path__ + "U-wHIkQ_AgupXdkBT/rdc_pro_logo.svg";